













































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Folder, FolderDtoIn, MoveFolderDtoIn, MoveEntityDtoIn, FolderEntites } from "@/services/folders/types";
import { PermitionEnum, HavePermition } from "@/components/security/Permitions";
import {
    createOrUpdateFolder,
    moveEntity,
    moveFolder
} from "@/services/folders/folderService";

@Component({
    name: "folder-node"
})
export default class FolderNode extends Vue {
    @Prop() private folder!: Folder;
    @Prop() private folderEntity!: FolderEntites;
    @Prop() private instance!: string;
    @Prop() private isRoot!: boolean;
    @Prop() private parentAllowDrop!: boolean;
    @Prop() private isDraggingFolder!: boolean;
    @Prop() private folderTree!: Vue;
    @Prop() private selectedFolder!: Folder;
    @Prop({ default: null }) private defaultSelection!: string | null;
    @Getter("getCurrentUser", { namespace: "authentication" }) currentUser: any;

    dragActive = false;
    timer = 0;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    isBeingDragged = false;

    // Watchers
    @Watch("folder.activateDelete")
    initiateDelete(value: boolean, oldValue: any) {
        if (value) this.$emit("remove", this.folder);
    }

    @Watch("isSelectedByDefault")
    selectIfDefaultSelection(value: boolean, oldValue: boolean) {
        if (value) {
            this.selectFolder(this.folder);
        }
    }

    // lifecycle hooks
    created() {
        if (this.isSelectedByDefault) {
            this.selectFolder(this.folder);
        }
    }

    // computed properties
    get isParent(): any {
        return this.folder.children && this.folder.children.length;
    }

    get allowDrop(): boolean {
        return this.parentAllowDrop &&
            !this.isBeingDragged &&
            (this.isDraggingFolder || (this.folder.claim ? this.folder.claim.includes("Access") : true));
    }

    get isSelectedByDefault(): boolean {
        return this.folder.id === this.defaultSelection ||
            (this.isRoot && this.defaultSelection === null && this.folder.id !== undefined);
    }

    // methods
    toggle() {
        if (this.isParent && !this.isRoot) {
            Vue.set(this.folder, "isOpen", !this.folder.isOpen);
        }
    }

    onSelection(event: any) {
        this.selectFolder(this.folder);
    }

    selectFolder(folder: Folder) {
        this.$emit("select-folder", folder);
        Vue.set(this.folder, "isOpen", true);
        // avoid navigation duplicate issue and not adding a qeuery in the route if folder tree is in modal
        if (this.$route.query.folder === folder.id || Object.entries(this.$route.params).length > 0) return;
        if (folder.parentFolderId !== null) {
            this.$router.replace({ query: { folder: folder.id } });
        } else if (this.$route.query.folder) {
            this.$router.replace({ query: { folder: undefined } });
        }
    }

    drag(event: any) {
        if (event.target.getAttribute("type") === "folder" && !this.havePermition(this.currentUser.permissions, this.permitionEnum[this.permitionEnum.MoveFolder])) {
            event.preventDefault();
            return;
        }
        this.isBeingDragged = true;
        this.folderTree.$emit("drag-folder-start");
        event.dataTransfer.setData(
            "type",
            event.target.getAttribute("type")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
    }

    dragEnd(event: any) {
        this.isBeingDragged = false;
        this.folderTree.$emit("drag-folder-stop");
    }

    dragEnter(event: any) {
        // Prevents from not allowed items being draged and droped on folder-tree
        const types = event.dataTransfer.types;
        if (!types.includes("entityid")) return;

        this.dragActive = true;
        this.startCount();
    }

    dragLeave(event: any) {
        // Prevents from not allowed items being draged and droped on folder-tree
        const types = event.dataTransfer.types;
        if (!types.includes("entityid")) return;

        this.dragActive = false;
        this.stopCount();
    }

    drop(event: any) {
        this.dragActive = false;
        const types = event.dataTransfer.types;
        if (!types.includes("entityid")) return;
        if (this.allowDrop) {
            const instance = this;
            const type = event.dataTransfer.getData("type") as string;
            const folderEntity = event.dataTransfer.getData("folderEntity") as FolderEntites;
            const entityId = event.dataTransfer.getData("entityId") as string;

            if (type.toLowerCase() === "folder") {
                moveFolder({
                    id: entityId,
                    targetFolderId: this.folder.id
                } as MoveFolderDtoIn).then(response => {
                    this.folderTree.$emit("folder-moved", {
                        folderId: entityId,
                        targetFolderId: instance.folder.id
                    });
                });
            } else {
                moveEntity({
                    entityId: entityId,
                    targetFolderId: this.folder.id,
                    folderEntity: folderEntity
                } as MoveEntityDtoIn).then(
                    response => {
                        this.folderTree.$emit(`entity-moved-event-finished`, {
                            entityId: entityId,
                            folderId: instance.folder.id
                        });
                    }
                );
            }
        }
        this.folderTree.$emit("drag-folder-stop");
        this.dragActive = false;
    }

    dragover(event: any) {
        event.preventDefault();
    }

    handleEnter() {
        this.transformFolder();
    }

    handleBlur() {
        if (this.folder.editMode) {
            this.transformFolder();
        }
    }

    transformFolder() {
        if (this.folder.name) {
            const folderDtoIn = {
                id: this.folder.id,
                name: this.folder.name,
                parentFolderId: this.folder.parentFolderId,
                folderEntity: this.folderEntity
            } as FolderDtoIn;
            createOrUpdateFolder(folderDtoIn).then(response => {
                this.folder.id = response;
                Vue.set(this.folder, "editMode", false);
            });
        } else {
            if (this.folder.id === "") {
                Vue.set(this.folder, "editMode", false);
                this.$emit("remove", this.folder);
            }
        }
    }

    removeSubFolder(folder: Folder) {
        if (this.folder.children) {
            const index = this.folder.children.findIndex(x => x.id === folder.id);
            if (index > -1) {
                this.folder.children.splice(index, 1);
            }
        }
    }

    startCount() {
        this.timer = setTimeout(this.openFolder, 750);
    }

    stopCount() {
        clearTimeout(this.timer);
    }

    openFolder() {
        this.stopCount();
        if (this.dragActive) Vue.set(this.folder, "isOpen", true);
    }
}
